<template>
  <div v-if="bannerImage" class="banner-container">
    <img class="banner-image" :src="bannerImage" alt="" :class="{ 'small': isMobile }" />
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapGetters } from 'vuex'

// Full-bleed store photo + name below the nav bar, same pattern as OWA's
// StoreSubHeader.vue (#bannerImage/#storeName) and reservation's shared
// app-shared-banner + SharedHeaderComponent's own storeName block
// (DEV-10685/DEV-10688/DEV-11112 unified header set). Kept as its own
// component, not folded into AppBar.vue, for the same reason reservation
// split app-shared-banner out of its header: it renders full-bleed edge to
// edge, so it needs to sit outside any width-capped page wrapper, not inside
// the toolbar.
export default {
  computed: {
    bannerImage() {
      // AppBar.vue's own logo (getMainImage) resolves the same way -- `origin`
      // + /v1, NOT process.env.VUE_APP_API_IMAGE, which isn't set at runtime
      // here (it rendered "undefined/attachment/..." when this used it).
      const mobilePath = get(this.getStore, 'images.MAIN[0].url')
      const desktopPath = get(this.getStore, 'images.DESKTOP_MAIN[0].url')
      const relativePath = this.isMobile ? mobilePath : (desktopPath || mobilePath)

      if (relativePath)
        return `${this.origin}/v1${relativePath}`
      return null
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },

    ...mapGetters([ 'getStore', 'origin' ])
  }
}
</script>

<style scoped>
  /* Byte-identical sizing to OWA's #bannerImage/.smallBannerImage
     (StoreSubHeader.vue) and reservation's .banner-image
     (banner.component.less), which both cite this same 25vh/178px/12.5vh
     rule as their source of truth. */
  .banner-container {
    width: 100%;
    overflow: hidden;
    background-color: #e8e4ea;
  }
  .banner-image {
    width: 100%;
    height: 25vh;
    max-height: 178px;
    object-fit: cover;
    display: block;
  }
  .banner-image.small {
    height: 12.5vh;
    max-height: 178px;
  }
</style>
